// Guided setup telemetry (GUIDED_SETUP_BUILD_SPEC §9): GA4 events through the
// gtag the page already loads. Only the listed properties, never personal data.
// A no-op when gtag isn't there (tests, blocked by the browser).

export type SetupEvent =
  | 'setup_ai_client'
  | 'setup_drawer_opened'
  | 'setup_step_detected'
  | 'setup_check_failed'
  | 'setup_admin_note_copied'
  | 'setup_completed'
  | 'setup_client_waitlist'
  | 'setup_invite_created';

export function trackSetup(event: SetupEvent, params: Record<string, string | number | boolean | undefined>): void {
  try {
    window.gtag?.('event', event, params);
  } catch {
    /* never let analytics break setup */
  }
}
